import get from 'lodash.get';

import { replaceText } from '../../helpers/mergeHelper';

import { shareEmailTitle } from '../../constants/shareEmailText';

export const replaceTextUsingTemplate = (template) => {
    const timeAndPlaceFields = template.timeAndPlaceFields || {};
    const extraFields = template.extraFields || {};

    return replaceText(template.text, {
        organisationName: template.organisationName,
        firstName: template.firstName,
        email: template.email,
        receiptNumber: template.receiptNumber,
        donationId: template.donationId,
        ...timeAndPlaceFields,
        ...extraFields
    });
}

export const getEmailTitle = campaign => {
    const emailTitle = get(campaign, 'template.value.customText.emailShareText.campaign.title');
    return emailTitle || shareEmailTitle
};

export const getEmailText = (campaign, model) => {
    const emailText = get(campaign, 'template.value.customText.emailShareText.campaign.text');
    if (emailText) {
        return replaceText(emailText, {
            organisationName: model.organisationName,
            campaignName: model.campaignName,
            campaignURL: model.campaignURL,
            goalAmount: model.goalAmount
        });
    }
    return "";
};